/**
 * @ Author: fangjy
 * @ Create Time: 2020-11-09 10:59:52
 * @ Modified by: fangjy
 * @ Modified time: 2020-11-13 16:11:24
 * @ Description:签约月嫂-确认服务页
 *              点击填写预产期
                点击选择服务顾问
                点击填写备注
                点击提交订单
                点击选择地址
                点击选择优惠券
 */
import { newTrackClick, newTrackView } from '@/utils/newTrack'

export const PAGE_LEVEL_ID = '121012509'

export const SUBMIT_MATERNITY = {
  event_name: '点击填写预产期',
  event_code: 200003
}

export const CHOOSE_ADVISER = {
  event_name: '点击选择服务顾问',
  event_code: 200004
}
export const REMARKS_REMARK = {
  event_name: '点击填写备注',
  event_code: 200005
}
export const SUBMIT_FORM = {
  event_name: '点击提交订单',
  event_code: 200006
}
export const CHOOSE_ADDRESS = {
  event_name: '点击选择地址',
  event_code: 200001
}
export const CHOOSE_COUPON = {
  event_name: '点击选择优惠券',
  event_code: 200002
}

export const trackView = () => {
  newTrackView(PAGE_LEVEL_ID)
}

export const trackClick = targetElement => {
  newTrackClick(
    PAGE_LEVEL_ID,
    targetElement.event_code,
    targetElement.event_name
  )
}
